import { render, staticRenderFns } from "./ElectronicInvoice.vue?vue&type=template&id=c5fa4cd2&"
import script from "./ElectronicInvoice.vue?vue&type=script&lang=js&"
export * from "./ElectronicInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports